// import networkIcon from '@assets/svg/risk/Network.svg';
// import dataIcon from '@assets/svg/risk/Data.svg';
// import identityIcon from '@assets/svg/risk/Identity.svg';
// import lateralMovementIcon from '@assets/svg/risk/LateralMovement.svg';
// import encryptionAtRestIcon from '@assets/svg/risk/EncryptionAtRest.svg';
// import encryptionInEncryptionIcon from '@assets/svg/risk/EncryptionInEncryption.svg';
// import highAvailabilityIcon from '@assets/svg/risk/HighAvailability.svg';
// import loggingAndMonitoringIcon from '@assets/svg/risk/LoggingAndMonitoring.svg';

import anomalousLogo from '@root/assets/svg/Risk/RiskPriority/anomalous.svg';
import adminLogo from '@root/assets/svg/Risk/RiskPriority/admin.svg';
import effectiveAdminLogo from '@root/assets/svg/Risk/RiskPriority/effective-admin.png';
// import effectiveAdminLogo from '@root/assets/svg/Risk/RiskPriority/effective-admin.svg';
import crossAccountLogo from '@root/assets/svg/Risk/RiskPriority/cross-account.svg';
import inactiveLogo from '@root/assets/svg/Risk/RiskPriority/inactive.png';
// import inactiveLogo from '@root/assets/svg/Risk/RiskPriority/inactive.svg';
import learningLogo from '@root/assets/svg/Risk/RiskPriority/learning.svg';
import noMfaLogo from '@root/assets/svg/Risk/RiskPriority/no-mfa.svg';
// import overPrivilegedLogo from '@root/assets/svg/Risk/RiskPriority/over-privileged.png';
import overPrivilegedLogo from '@root/assets/svg/Risk/RiskPriority/over-privileged.svg';
import threatLogo from '@root/assets/svg/Risk/RiskPriority/threat.svg';
import accessKey1NotRotatedLogo from '@root/assets/svg/Risk/RiskPriority/access-key1-not-rotated.svg';
import accessKey2NotRotatedLogo from '@root/assets/svg/Risk/RiskPriority/access-key2-not-rotated.svg';
import rootUserLogo from '@root/assets/svg/Risk/RiskPriority/root-user.svg';
// import lateralMovementLogo from '@root/assets/svg/Risk/RiskPriority/lateral-movement.svg';
import lateralMovementLogo from '@root/assets/svg/Cloud_Events/lateral-movement.svg';
import permissionManagementLogo from '@root/assets/svg/Risk/RiskPriority/permission-management.png';
// import permissionManagementLogo from '@root/assets/svg/Risk/RiskPriority/permission-management.svg';
import dataAccessLogo from '@root/assets/svg/Risk/RiskPriority/data-access.svg';
import infrastructureModificationLogo from '@root/assets/svg/Risk/RiskPriority/infrastructure-modification.svg';
import reconnaissanceLogo from '@root/assets/svg/Risk/RiskPriority/reconnaissance.svg';
import credentialExposureLogo from '@root/assets/svg/Risk/RiskPriority/credential-exposure.svg';
import environmentAccessLogo from '@root/assets/svg/Risk/RiskPriority/environment-access.svg';
import priviledgeLogo from '@root/assets/svg/Risk/RiskPriority/privledge.png';
// import priviledgeLogo from '@root/assets/svg/Risk/RiskPriority/privledge.svg';
import privilegeEscalationLogo from '@root/assets/svg/Risk/RiskPriority/privilege-escalation.svg';
import multipleAccessKeysActiveLogo from '@root/assets/svg/Risk/RiskPriority/multiple-access-keys-active.png';
// import multipleAccessKeysActiveLogo from '@root/assets/svg/Risk/RiskPriority/multiple-access-keys-active.svg';
import operationsLogo from '@root/assets/svg/Risk/RiskPriority/operations.svg';
import credentialAccessIcon from '@root/assets/svg/Cloud_Events/credential_access.png';
import attackPathLogo from '@root/assets/svg/Risk/RiskPriority/attack_path.svg';
import thirdPartyLogo from '@root/assets/svg/Cloud_Events/third-party-logo.svg';
import availabilityOperationsLogo from '@root/assets/svg/Cloud_Events/availability-operations.svg';
import identityAccessLogo from '@root/assets/svg/Cloud_Events/identity-access.svg';
import supplyChainLogo from '@root/assets/svg/Cloud_Events/supply-chain.svg';
import vulnerabilityManagementLogo from '@root/assets/svg/Cloud_Events/vulnerability-management.svg';
import workloadHardeningLogo from '@root/assets/svg/Cloud_Events/workload-hardening.svg';
import governanceHygieneLogo from '@root/assets/svg/Cloud_Events/governance-hygiene.svg';

import Tooltip from '@root/components/v2/ui-elements/Tooltip';

const IMAGE_MAP = {
  ['Effective Admin']: effectiveAdminLogo,
  ['Admin']: adminLogo,
  ['Cross Account']: crossAccountLogo,
  ['Inactive']: inactiveLogo,
  ['Over Privileged']: overPrivilegedLogo,
  ['Anomalous']: anomalousLogo,
  ['Learning']: learningLogo,
  ['Threat']: threatLogo,
  ['No Mfa']: noMfaLogo,
  ['Access Key 1 Not Rotated']: accessKey1NotRotatedLogo,
  ['Access Key 2 Not Rotated']: accessKey2NotRotatedLogo,
  ['Multiple Access Keys Active']: multipleAccessKeysActiveLogo,
  ['Root User']: rootUserLogo,
  ['Privileged']: priviledgeLogo,
  ['Privilege Escalation']: privilegeEscalationLogo,
  ['Lateral Movement']: lateralMovementLogo,
  ['Permission Management']: permissionManagementLogo,
  ['Data Access']: dataAccessLogo,
  ['Infrastructure Modification']: infrastructureModificationLogo,
  ['Reconnaissance']: reconnaissanceLogo,
  ['Credential Exposure']: credentialExposureLogo,
  ['Environment Access']: environmentAccessLogo,
  ['Operational']: operationsLogo,
  ['Credential Access']: credentialAccessIcon,
  ['Attack path']: attackPathLogo,
  ['Attack Path']: attackPathLogo,
  ['Attack paths']: attackPathLogo,
  ['Third Party']: thirdPartyLogo,
  ['Availability & Operations']: availabilityOperationsLogo,
  ['Availability And Operations']: availabilityOperationsLogo,
  ['Identity & Access']: identityAccessLogo,
  ['Identity And Access']: identityAccessLogo,
  ['Supply Chain']: supplyChainLogo,
  ['Vulnerability Management']: vulnerabilityManagementLogo,
  ['Workload Hardening']: workloadHardeningLogo,
  ['Governance & Hygiene']: governanceHygieneLogo,
  ['Governance And Hygiene']: governanceHygieneLogo,
};
export const RiskPriorityIcons = ({ name, rowIndex, width = '25px', height = '25px' }) => {
  return (
    // <div style={{ paddingRight: paddingRight }}>
    <Tooltip title={name === 'No Mfa' ? 'No MFA' : name} isIcon={true} arrow>
      <img
        id={`${name?.toLowerCase()}-${rowIndex}`}
        src={IMAGE_MAP[name]}
        style={{ objectFit: 'contain', width: width, height: height }}
        alt={name}
      />
    </Tooltip>
    // </div>
  );
};
